// src/components/padrekko/qc/builder/CaseBuilderBanner.jsx
//
// Top-of-map banner for the case-builder mode. Shows the mode instruction +
// pad count and carries Continue / Cancel (logic in useCaseBuilderActions).
// "Continue to case details" hands the draft to NewCaseForm; it does not
// create the case.

import { ArrowRight, X, MapPin } from "lucide-react";
import { useCaseBuilderStore } from "../../../../stores/useCaseBuilderStore";
import { useCaseBuilderActions } from "./useCaseBuilderActions";

export default function CaseBuilderBanner() {
  const padCount = useCaseBuilderStore((s) => s.pads.length);
  const { continueToDetails, cancel, canContinue, blockReason } = useCaseBuilderActions();

  return (
    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-30 pointer-events-auto">
      <div className="flex items-center gap-3 bg-[#102536] border border-slate-700 border-l-[3px] border-l-accent-info rounded-lg px-4 py-2 shadow-lg">
        <div className="flex items-center gap-2 text-[12.5px] text-fg-primary">
          <MapPin size={14} className="text-accent-info" />
          <span className="font-medium">Create case</span>
          <span className="text-fg-secondary">— shift-drag to lasso points</span>
        </div>
        <span className="text-[12px] text-fg-secondary tabular-nums">
          {padCount} {padCount === 1 ? "pad" : "pads"}
        </span>
        <div className="flex items-center gap-1.5 pl-1">
          <button
            onClick={cancel}
            className="flex items-center gap-1 text-[12px] font-medium text-fg-secondary hover:text-slate-200 transition border border-slate-700 rounded-md px-2.5 py-1"
          >
            <X size={13} /> Cancel
          </button>
          <button
            onClick={continueToDetails}
            disabled={!canContinue}
            title={blockReason ?? "Continue to case details"}
            className="flex items-center gap-1 text-[12px] font-medium text-bg bg-accent-action hover:brightness-110 transition rounded-md px-2.5 py-1 disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Continue <ArrowRight size={13} />
          </button>
        </div>
      </div>
      {blockReason && (
        <div className="mt-1 text-center text-[11px] text-amber-300/90">{blockReason}</div>
      )}
    </div>
  );
}
